import * as React from 'react';
import { RouteComponentProps, withRouter, Link, NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { PageProps } from "src/models/common/ComponentProps";
import { Row, Col, Icon, Spin, Table, Input, Button } from "antd";
import ReportApiController from "src/api/ReportApiController";

import { ReduxStoreModel } from "src/redux/ReduxModel";
import { UserState } from "src/redux/UserReducer";
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import PrincipalReportResponseDTO from "src/models/report/PrincipalReportResponseDTO";
import DataTable, { DataTableButton } from 'src/components/common/DataTable';

interface RouteParams {
    schoolId: string;
}

interface PrincipalReportProps extends PageProps<RouteParams>, LocalizeContextProps {
    // Redux
    User: UserState;
}

interface PrincipalReportState {
    teachers: PrincipalReportResponseDTO[];
    isLoading: boolean;
}

class PrincipalReport extends React.Component<PrincipalReportProps, PrincipalReportState> {
    constructor(props: PrincipalReportProps) {
        super(props);
        bindAllOfThis(this, PrincipalReport.prototype);

        this.state = {
            teachers: [],
            isLoading: true,
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
    }

    componentWillReceiveProps(nextProps: PrincipalReportProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage) {
            this.deriveStateFromProps(nextProps);
        }
    }

    deriveStateFromProps(props: PrincipalReportProps) {
        ReportApiController.getPrincipalReport().then(response => {
            if (response.ok) {
                this.setState({
                    teachers: response.data,
                    isLoading: false
                });
            }
        });
    }

    render() {
        if (this.state.isLoading) {
            return <div className="teacher-reports">
                <h2><Translate id="report.principal.headerText" /></h2>
                <p><Translate id="report.classroom.loadingText" /></p>
                <Spin />
            </div>;
        }
        return <div className="teacher-reports">
            <DataTable
                data={this.state.teachers}
                className="report-container-new"
                tableProps={{ loading: this.state.isLoading }}
                columns={[
                    DataTable.StandardColumns.Text("report.principal.header.teacherName", "teacherName"),
                    DataTable.StandardColumns.Text("report.principal.header.percent", "percentComplete"),
                ]}
                buttonBar={[
                    new DataTableButton("dataTable.export", () => window.location.href = "/" + ReportApiController.RouteExportPrincipalReport())
                ]}
            />
        </div>;
    }
}


function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(withLocalize(PrincipalReport));



// WEBPACK FOOTER //
// ./src/pages/admin/PrincipalReport.tsx